export default __webpack_public_path__ + "img/icon-up.asset.0ea7ee8c.png";